import React, { useState } from 'react'
import Button from '../components/Button';

import animationData from "../animation/filter.json"
import Lottie from 'lottie-react';
import ContactFormPopup from '../components/ContactFormPopup';
import { Link } from 'react-router-dom';

const HomeContactSection = () => {
      const [popUpActive, setPopupActive] = useState(false);
    
    return (
        <>
            <div className='flex flex-col md:flex-row xl:px-35 px-10 xl:pr-65 xl:items-center justify-between dark:text-white xl:py-20 py-10 pointer-events-auto'>
                <div className='xl:w-[35vw] md:w-[30vw] w-full overflow-hidden mb-6 md:mb-0'>
                    <div className="flex justify-center items-center  scale-[1.5] ">
                        <Lottie animationData={animationData} loop autoplay className='xl:w-[40vw] xl:h-[40vw] md:w-[25vw] md:h-[25vw] h-[100vw] w-[100vw] max-w-sm' />
                    </div>
                </div>
                <div className='xl:w-[40vw] md:w-[60vw] w-full space-y-5'>
                    <div className="">
                        <h3 className='text-md text-zinc-500 font-semibold'>DIGICOTS</h3>
                        <h1 className="text-4xl font-bold ">
                            Applied marketing <br />
                            to build customer loyalty.
                        </h1>
                    </div>
                    <div className="">
                        <p className="text-lg dark:text-zinc-200 text-zinc-700 ">We boost your online presence with our great online reputation management services that connect with your audience and maximise your engagement.</p>
                    </div>
                    <div>
                        <h2 className='text-lg font-semibold'>Objectives Achieved</h2>
                    </div>


                    {/* Progress Section */}
                    <div className="w-full relative ">
                        <div style={{ left: 'calc(97% - 1.5rem)' }} className="absolute -top-[400%] flex justify-end items-center ">
                            <span className="text-sm font-bold dark:text-white dark:bg-zinc-800 bg-zinc-200 py-[2px]  px-2 rounded-xl">
                                97%
                            </span>
                        </div>
                        <div className="w-full h-2 dark:bg-gray-600 bg-zinc-300 rounded-full overflow-hidden">
                            <div
                                className="h-full bg-gradient-to-r from-[#D70A31] to-[#7945DB] transition-all duration-700 ease-out"
                                style={{ width: `97%` }}
                            ></div>
                        </div>
                    </div>
                    {/* <Button onClick={() => setPopupActive(true)}>Get in touch</Button> */}
                    <Link to={"/contact"}>
                    <Button >Get in touch</Button>
                    </Link>

                </div>
            </div>
            <ContactFormPopup isActive={popUpActive} onClose={() => setPopupActive(false)} />

        </>
    )
}


export default HomeContactSection;